import React from 'react'
import { Modal, Form, Select, DatePicker, Input, Button, theme } from 'antd'
import { hexToRGBA } from '../../../../lib/utils'
import { UserAddOutlined, CloseOutlined } from '@ant-design/icons'

const { Option } = Select

const NewAdmissionModal = ({ isVisible, onCancel, onAdd, form, departments }) => {
  const { token } = theme.useToken()

  const modalFooter = [
    <Button
      key='cancel'
      onClick={onCancel}
      icon={<CloseOutlined style={{ color: token.colorError }} />}
      style={{
        background: hexToRGBA(token.colorError, 0.1),
        borderColor: token.colorError,
        color: token.colorError,
        fontWeight: 'bold'
      }}
    >
      Cancel
    </Button>,
    <Button
      key='submit'
      onClick={onAdd}
      icon={<UserAddOutlined style={{ color: token.colorSuccess }} />}
      style={{
        background: hexToRGBA(token.colorSuccess, 0.1),
        borderColor: token.colorSuccess,
        color: token.colorSuccess,
        fontWeight: 'bold'
      }}
    >
      Admit Patient
    </Button>
  ]

  return (
    <Modal title='New Patient Admission' open={isVisible} onCancel={onCancel} footer={modalFooter} width={700}>
      <Form form={form} layout='vertical'>
        <Form.Item name='patientId' label='Patient ID' rules={[{ required: true, message: 'Please select a patient' }]}>
          <Select placeholder='Select patient' showSearch optionFilterProp='children'>
            <Option value='PT-1001'>John Smith (PT-1001)</Option>
            <Option value='PT-1023'>Emma Wilson (PT-1023)</Option>
            <Option value='PT-1045'>Michael Brown (PT-1045)</Option>
            {/* More options would be populated from patients database */}
          </Select>
        </Form.Item>

        <Form.Item
          name='dateOfAdmission'
          label='Date of Admission'
          rules={[{ required: true, message: 'Please select admission date and time' }]}
        >
          <DatePicker showTime style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name='reasonForAdmission'
          label='Reason for Admission'
          rules={[{ required: true, message: 'Please enter reason for admission' }]}
        >
          <Input.TextArea rows={2} />
        </Form.Item>

        <Form.Item
          name='attendingPhysician'
          label='Attending Physician'
          rules={[{ required: true, message: 'Please select attending physician' }]}
        >
          <Select placeholder='Select physician'>
            <Option value='Dr. Sarah Johnson'>Dr. Sarah Johnson</Option>
            <Option value='Dr. Robert Chen'>Dr. Robert Chen</Option>
            <Option value='Dr. Emily Taylor'>Dr. Emily Taylor</Option>
            <Option value='Dr. James Wilson'>Dr. James Wilson</Option>
            {/* More options would be populated from staff database */}
          </Select>
        </Form.Item>

        <Form.Item
          name='department'
          label='Department'
          rules={[{ required: true, message: 'Please select department' }]}
        >
          <Select placeholder='Select department'>
            {departments.map((dept) => (
              <Option key={dept} value={dept}>
                {dept}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='roomAssigned'
          label='Room Assignment'
          rules={[{ required: true, message: 'Please select a room' }]}
        >
          <Select placeholder='Select room'>
            <Option value='A-201'>A-201</Option>
            <Option value='B-105'>B-105</Option>
            <Option value='C-310'>C-310</Option>
            <Option value='D-112'>D-112</Option>
            {/* More options would be populated from available rooms */}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default NewAdmissionModal
